<template>
  <el-dialog
    v-if="isVisible"
    v-model="isVisible"
    title="This patient already exists"
    class="duplicate-patient-dialog order-test"
    @close="close"
  >
    <slot name="content">
      <p class="content-text">
        Can you check the patient information you entered, and confirm if you want to continue to use this patient's info.
      </p>
    </slot>
    
    <div class="grid grid-cols-4 mt-4 table-header">
      <p class="col-span-2 ml-4">Patient Name</p>
      <p>Biological Sex</p>
      <p>DOB</p>
    </div>
    <div class="grid grid-cols-4 table-content">
      <p class="col-span-2 ml-4">{{ name }}</p>
      <p>{{ gender }}</p>
      <p>{{ dob }}</p>
    </div>

    <div class="mt-10">
      <slot name="footer">
        <div class="flex justify-end">
          <slot name="buttons">
            <el-button class="mr-6 cancel-btn" @click="close">Cancel</el-button>
            <el-button class="confirm-btn" @click="confirm">Yes, Confirm</el-button>
          </slot>
        </div>
      </slot>
    </div>
  </el-dialog>
</template>

<script>
import { notify } from '@/utils/notify';

export default {
  emits: ["close", "confirm"],
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ""
    },
    gender: {
      type: String,
      default: ""
    },
    dob: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      isVisible: this.isShowDialog
    }
  },

  watch: {
    isShowDialog(newVal) {
      this.isVisible = newVal;
    }
  },

  methods: {
    close() {        
      this.$emit("close");
    },

    confirm() {
      let patientId = this.id;
      if (isNaN(patientId)) {
        let message = "Invalid patient id: " + patientId
        notify({ type: 'error', message });
        return;
      }
      this.$emit("confirm", patientId);
    }
  }
}
</script>

<style scoped>
.content-text {
  width: 478px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #979797;
  word-break: normal;
}

.table-header {
  background: #20A8C3;
  border: 1px solid #20A8C3;
  font-weight: 500;
  font-size: 15px;
  line-height: 26px;
  color: #FFFFFF;
}

.table-content {
  background: #F8FAFB;
  font-size: 15px;
  font-weight: 400;
  line-height: 26px;
  color: #000000;
}

.cancel-btn {
  background: #E6E6E6;
  mix-blend-mode: normal;
  border-radius: 4px;
  border-color: #E6E6E6;
  width: 180px;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.429px;
  color: #4A4A4A;
}
.cancel-btn:active {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.confirm-btn {
  width: 180px;
  background: #20A8C3;
  border-radius: 4px;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.0043em;
  color: #F5F5F5;
}

.confimr-btn:active {
  background: #0C96B1;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
</style>